module.exports = __webpack_public_path__ + "static/media/selfmanagement.6b446dfd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/selfmanagement.svg
// module id = 2461
// module chunks = 0